import {MutableState} from "final-form";

const setFieldTouched = <T extends [string, boolean, ...unknown[]], U>(
    args: [...T],
    state: MutableState<U>,
): void => {
    const [name, touched] = args;
    const field = state.fields[name as string];
    if (field) {
        field.touched = !!touched;
    }
};

export default setFieldTouched;
